import loader from './loading.gif'

const Loader = () => {
    return (
        <div className="loader">
            <img src={ loader } alt="Loading" />
        </div>
    )
}

export default Loader
